var exports = {
  "n3": "xaee3c4fa--692d11--social-network",
  "jV": "xaee3c4fa--692d11--social-network__comment-btn",
  "ee": "xaee3c4fa--692d11--social-network__comment-canot",
  "Fd": "xaee3c4fa--692d11--social-network__icons",
  "Wq": "xaee3c4fa--692d11--social-network__icons_aligned",
  "vB": "xaee3c4fa--692d11--social-network__icons_tg",
  "xb": "xaee3c4fa--692d11--social-network__icons_vk",
  "Y4": "xaee3c4fa--692d11--social-network__icons_ok",
};

module.exports = exports;
